import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Button, InputX, Input, Select, LayerBottom, Toast } from 'components'
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { useNavigate, useLocation } from 'react-router-dom'
import Lib from 'library'
import { useSetRecoilState } from 'recoil'
import { userLogInfoState } from '../states'


const Form = () => {

	const App = useApp()
	const mounted = useRef()
	const navigate = useNavigate()
	const location = useLocation()

	const setUserInfo = useSetRecoilState(userLogInfoState)

	const [showLayer, setShowLayer] = useState(false)
	const [showToast, setShowToast] = useState(false)
	const [showRed, setShowRed] = useState(false)

	const [telecomList, setTelecomList] = useState()

	// 폼벨류
	const [telecom, setTelecom] = useState()
	const [telNum, setTelNum] = useState("")
	const [userName, setUserName] = useState("")
	const [socialNum1, setSocialNum1] = useState("")
	const [socialNum2, setSocialNum2] = useState("")

	const [buttonDisabled, setButtonDisabled] = useState(true)
	const [toastText, setToastText] = useState("")

	const telSelect = useRef()
	const social2 = useRef()

	// page type
	const pageType = useMemo(() => location.pathname === "/resetPassword" ? "reset" : "join")

	// step
	const [step, setStep] = useState(0)

	const getTelecomList = async () => {
		const list = await Lib.getCommonCode("TCOM")
		if (!list) {
			setTelecomList([
				{
					key: "SKT",
					value: "SKT"
				},
				{
					key: "KT",
					value: "KT"
				},
				{
					key: "LGU+",
					value: "LGT"
				},
				{
					key: "SKT 알뜰폰",
					value: "SKM"
				},
				{
					key: "KT 알뜰폰",
					value: "KTM"
				},
				{
					key: "LGU+ 알뜰폰",
					value: "LGM"
				},
			])
		} else {
			setTelecomList(list.map(item => {
				return {
					key: item.commNm,
					value: item.commCd
				}
			}))
		}
	}

	const takeStep = () => {
		if (step < 2) {
			setStep(step => step += 1)
			setButtonDisabled(true)
		} else {
			switch (Lib.isAdult(socialNum1)) {
				case undefined:
					setToastText("잘못된 주민번호입니다.")
					setShowToast(true)
					break
				case false:
					setShowLayer(true)
					break
				case true:
					setUserInfo(info => {
						// 2022.11.10 LBJ : info 는 동의한 term(약관) 정보(termsCd, termsVer) 배열
						return {
							...info,
							cphNo: telNum,
							nm: userName,
							rsdtRegNo: `${socialNum1}${socialNum2}`,
							tcomCd: telecom
						}
					})

					let url
					if (pageType === "reset") {
						url = `/api/mb/login/auth/req`
					} else {
						url = `/api/mb/join/auth/req`
					}

					Lib.post(url, {
						cphNo: telNum,
						nm: userName,
						rsdtRegNo: `${socialNum1}${socialNum2}`,
						tcomCd: telecom
					}, data => {
						setShowRed(false)
						let url = "/verify"
						const info = {
							cphNo: telNum,
							nm: userName,
							rsdtRegNo: `${socialNum1}${socialNum2}`,
							tcomCd: telecom
						}
						if (pageType === "reset") {
							url = "/verifyPassword"
							info.reset = true
						}
						navigate(url, {
							state: {
								info: info
							}
						})
					}, error => {
						setShowRed(true)
					})

					/* navigate("/joinNumber", {
						state: {
							info: {
								cphNo: telNum,
								nm: userName,
								rsdtRegNo: `${socialNum1}${socialNum2}`,
								tcomCd: telecom
							}
						}
					}) */
					break
			}
		}
	}

	useEffect(() => {
		console.log(telecomList)
	}, [telecomList])

	useEffect(() => {
		switch (step) {
		    case 0:
		        document.querySelector("[name='userName']").focus()
		        break
			case 1:
			    document.querySelector("[name='userName']").blur()
				document.querySelector("[name='socialNum1']").focus()
				break
			case 2:
			    document.querySelector("[name='socialNum1']").blur()
                document.querySelector("[name='socialNum2']").blur()
				telSelect.current.show()
				break
		}
	}, [step])

	useEffect(() => {
		if (
			step >= 0 && userName.length === 0
			||
			step >= 1 && (socialNum1.length < 6 || socialNum2.length < 1)
			||
			step >= 2 && (typeof telecom === "undefined" || telNum.length < 10)
		) {
			setButtonDisabled(true)
		} else {
			setButtonDisabled(false)
		}
	}, [userName, telecom, telNum, socialNum1, socialNum2])

	useEffect(() => {
		mounted.current = true

		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		mounted.current && getTelecomList()

		return () => mounted.current = false
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				{
					pageType === "reset" &&
					<>
						<div className={styles["join-box"]}>
							<p>비밀번호 재설정을 위해서는 회원정보<br />절차가 필요해요.</p>
							<p className="mt_20">번거로우시겠지만, 정보를 입력 후<br />비밀번호를 재설정해주세요.</p>
						</div>
						<h3 className="mt_30">
							{
								pageType === 'reset'
									? step === 0 
										? '이름을 입력해주세요.' 
										: step === 1 
											? '주민등록번호를 입력해주세요.'
											: step === 2
												? '통신사 및 휴대폰번호를 입력해주세요.'
												: '입력정보 확인'
									: '입력정보 확인'	
							}

						</h3>
					</>
					||
					<h3>
					{
						pageType === 'join'
							? step === 0 
								? '이름을 입력해주세요.' 
								: step === 1 
									? '주민등록번호를 입력해주세요.'
									: step === 2
										? '통신사 및 휴대폰번호를 입력해주세요.'
										: '입력정보 확인'
							: '입력정보 확인'				
					}
					</h3>
				}
				{
					showRed &&
					<span className={`${styles.warn} mt_10 text-red`}>입력하신 정보를 다시 확인해주세요.</span>
				}

				{
					step >= 2 &&
					<>
						<p className="guide-title mt_40">휴대폰번호</p>
						<div className="flex-align_center mt_10">
							<Select ref={telSelect} placeholder="선택" title="통신사" style={{ width: "12rem" }} selected={telecom} data={telecomList} onSelect={(key, value) => {
								setTelecom(value)
								document.querySelector("[name='telNum']").focus()
							}}>
							</Select>
							<InputX name="telNum" tabindex="4" type="tel" placeholder="휴대폰 번호 입력" defaultValue={telNum} setValue={setTelNum} className="flex--item_1 ml_20" maxlength="11" onChange={e => {
								setTelNum(e.target.value)
							}} onKeyPress={e => {
								if (!buttonDisabled && e.which === 13) takeStep()
							}} />
						</div>
					</>
				}

				{
					step >= 1 &&
					<>
						<p className="guide-title mt_40">주민등록번호</p>
						<div className="flex-align_center mt_10" style={{ position: "relative" }}>
							<InputX name="socialNum1" tabindex="2" type="tel" placeholder="주민번호 앞 6자리" defaultValue={socialNum1} setValue={setSocialNum1} className="flex_1" maxlength="6" onChange={e => {
								setSocialNum1(e.target.value)
								if (e.target.value.length >= 6) social2.current.focus()
							}} onKeyPress={e => {
								if (e.which === 13) {
									social2.current.focus()
								}
							}} />
							<span style={{ margin: "0 0.5rem" }}>-</span>
							<div className="flex--item_1">
								<Input ref={social2} name="socialNum2" tabindex="3" type="tel" style={{ width: "3rem", paddingRight: 0, textAlign: "center" }} maxlength="1" onChange={e => {
									setSocialNum2(e.target.value)
								}} onKeyPress={e => {
									if (!buttonDisabled && e.which === 13) takeStep()
								}} />
								<div className="floating-dots">
									<span />
									<span />
									<span />
									<span />
									<span />
									<span />
								</div>
							</div>
						</div>
					</>
				}

				<p className="guide-title mt_40">이름</p>
				<InputX name="userName" tabindex="1" type="text" placeholder="이름 입력" focus="true" setValue={setUserName} className="mt_10" onChange={e => {
					let value = e.target.value
					value = value.replace(/ㄱ-ㅎ가-힇ㆍ ᆢ/g, "")
					e.target.value = value
					setUserName(value)
				}} onKeyPress={e => {
					if (!buttonDisabled && e.which === 13) takeStep()
				}} />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={takeStep}>다음</Button>
			</div>

			<ConfirmLayer show={showLayer} closeLayer={() => setShowLayer(false)} setShowRedConfirm={setShowRed} />

			<Toast show={showToast} setShow={setShowToast} text={toastText} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer, setShowRedConfirm }) => {
	if (show) {
		setShowRedConfirm(true);
	}

	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div>
				<div className="flex-justify_center">
					<i className="icon icon_report_intro" style={{ width: "7rem", height: "6rem" }} />
				</div>
				<div className="layer-text mt_20">
					<p>모니 앱은 만 19세 이상 회원 가입 및 이용이 가능해요.</p>
					<span style={{ color: "#999" }}>정보 확인 후 다시 시도 해주세요.</span>
				</div>
			</div>
		</LayerBottom>
	)
}

export default Form